export default __webpack_public_path__ + "static/media/Support.c39f1982.svg";